export default "__VITE_ASSET__52155ebf__"